const {reveal}=require('./transition.js');
document.querySelectorAll('[data-case-preview]').forEach(preview=>{
 const buttons=[...preview.querySelectorAll('button[data-case-mode]')],panels=[...preview.querySelectorAll('[data-case-panel]')];
 buttons.forEach(button=>button.addEventListener('click',()=>{
  const mode=button.dataset.caseMode;
  preview.dataset.caseMode=mode;
  buttons.forEach(item=>item.setAttribute('aria-pressed',String(item===button)));
  panels.forEach(panel=>{panel.hidden=panel.dataset.casePanel!==mode;});
  const panel=panels.find(item=>!item.hidden);if(panel)reveal(panel);
 }));
});

const viewer=document.querySelector('[data-project-viewer]');
if(viewer&&typeof viewer.showModal==='function'){
 const links=[...document.querySelectorAll('[data-project-lightbox]')];
 const images=[...new Map(links.map(link=>[link.href,{src:link.href,caption:link.dataset.caption,alt:link.querySelector('img')?.alt||link.dataset.caption}])).values()];
 const img=viewer.querySelector('[data-viewer-image]'),caption=viewer.querySelector('[data-viewer-caption]');
 let current=0,trigger=null;
 const show=index=>{
  current=(index+images.length)%images.length;
  img.src=images[current].src;img.alt=images[current].alt;
  caption.textContent=`${String(current+1).padStart(2,'0')} / ${String(images.length).padStart(2,'0')} · ${images[current].caption}`;
 };
 links.forEach(link=>link.addEventListener('click',event=>{
  if(event.metaKey||event.ctrlKey||event.shiftKey||event.altKey)return;
  event.preventDefault();trigger=link;show(images.findIndex(image=>image.src===link.href));
  viewer.showModal();document.documentElement.classList.add('project-viewer-open');viewer.querySelector('[data-viewer-close]').focus();
 }));
 viewer.querySelector('[data-viewer-close]').addEventListener('click',()=>viewer.close());
 viewer.querySelector('[data-viewer-prev]').addEventListener('click',()=>show(current-1));
 viewer.querySelector('[data-viewer-next]').addEventListener('click',()=>show(current+1));
 viewer.addEventListener('keydown',event=>{if(event.key==='ArrowLeft'||event.key==='ArrowRight'){event.preventDefault();show(current+(event.key==='ArrowRight'?1:-1));}});
 viewer.addEventListener('click',event=>{if(event.target===viewer){const rect=viewer.getBoundingClientRect();if(event.clientX<rect.left||event.clientX>rect.right||event.clientY<rect.top||event.clientY>rect.bottom)viewer.close();}});
 viewer.addEventListener('close',()=>{document.documentElement.classList.remove('project-viewer-open');trigger?.focus({preventScroll:true});});
 if(images.length<2){viewer.querySelector('[data-viewer-prev]').hidden=true;viewer.querySelector('[data-viewer-next]').hidden=true;}
}
